module.exports = __webpack_public_path__ + "img/geo.0300927d.svg";